export const Home = (): JSX.Element => {
  return <div id="home" className="section"></div>;
};
